import { cssVar } from '@/styles/tokens'
import type { ColorToken } from '@/styles/tokens'

/**
 * `span.avatar` → `avatar` (process/08-COMPONENT-CATALOGUE.md). Prototype_v2.html's own `.avatar`
 * rule: 20×20px → `sp-9` (0 delta); border-radius 50% → `r-pill`; font-size 8.5px → `fs-micro`
 * (+1.5px delta, the same tolerance class W139's own token map already accepts elsewhere);
 * font-weight 800 → `fw-heavy`; margin-right 6px → `sp-3`; colour is always white text on a coloured
 * fill, never the reverse.
 *
 * Initials are derived from `name` the same way the prototype's own fixture data is: two letters,
 * first-plus-last word if there are at least two words, otherwise the name's own first two
 * characters — a presentational derivation, not a served or inferred business value.
 */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length < 2) return (parts[0] ?? '').slice(0, 2).toUpperCase()
  return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase()
}

export function Avatar({ name, color = 'slate' }: { name: string; color?: ColorToken }) {
  return (
    <span
      data-cmp="avatar"
      style={{
        width: cssVar('sp-9'),
        height: cssVar('sp-9'),
        borderRadius: cssVar('r-pill'),
        fontSize: cssVar('fs-micro'),
        fontWeight: cssVar('fw-heavy'),
        marginRight: cssVar('sp-3'),
        background: cssVar(color),
      }}
      className="inline-grid place-items-center text-white align-middle"
    >
      {initials(name)}
    </span>
  )
}
